import script from "./OpportunityShow.vue?vue&type=script&setup=true&lang=js"
export * from "./OpportunityShow.vue?vue&type=script&setup=true&lang=js"

import "./OpportunityShow.vue?vue&type=style&index=0&id=33148976&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33148976"]])

export default __exports__